import React from 'react';
import { MapPinIcon, PhoneIcon } from 'lucide-react';
import { ANY_SERVICE, HeroLeadForm } from './HeroLeadForm';
import { business, photos } from '../data/site';
export function Hero() {
  return <section id="top" className="relative w-full bg-ink text-white" data-id="element-197" data-mp="9ka68zwg6uxg">
      <div className="absolute inset-0" data-id="element-198" data-mp="9ih0dmtnseqi">
        <img src={photos.heroExterior} alt="East End Automotive Repair exterior at dusk with illuminated shop sign in Oak Ridge, Tennessee" className="h-full w-full object-cover object-[58%_center] lg:object-center" data-id="element-199" data-mp="4mrul1r1q1lr" />
        <div className="absolute inset-0 bg-ink/65 lg:bg-ink/50" data-id="element-200" data-mp="x8jjhdfliacz" />
      </div>

      <div className="relative mx-auto max-w-shell px-5 pb-16 pt-14 lg:px-8 lg:pb-20 lg:pt-16" data-id="element-201" data-mp="s9gj46ak8sbc">
        <div className="grid grid-cols-[minmax(0,1fr)] gap-y-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,400px)] lg:items-start lg:gap-x-14 lg:gap-y-0" data-id="element-202" data-mp="nbyj55eitnfh">
          <div className="order-1 min-w-0 lg:col-start-1 lg:row-start-1" data-id="element-203" data-mp="381xl8y8vx2a6">
            <p className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.18em] text-brand-light" data-id="element-204" data-mp="3j8ixl0k6uiv8">
              <MapPinIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-205" data-mp="3o85bzdbr655m" />
              Oak Ridge, Tennessee
            </p>

            <h1 className="mt-5 font-display text-[36px] font-extrabold leading-[1.03] tracking-[-0.02em] sm:text-[50px] lg:text-[58px]" data-id="element-206" data-mp="399jmlbbyab52">
              Honest diagnosis.
              <br data-id="element-207" data-mp="30hhqfp8wzh0l" />
              Clear answers.
              <span className="block text-brand-light" data-id="element-208" data-mp="30gq3t3xaotmg">
                Specializing in professional results.
              </span>
            </h1>
          </div>

          <div className="order-2 min-w-0 lg:order-none lg:col-start-2 lg:row-span-2 lg:row-start-1" data-id="element-209" data-mp="2qkmtvbw7bqoy">
            <HeroLeadForm defaultService={ANY_SERVICE} sourcePage="home" data-id="element-210" data-mp="2vjzpom51w83o" />
          </div>

          <div className="order-3 min-w-0 lg:col-start-1 lg:row-start-2 lg:mt-6" data-id="element-211" data-mp="2hix03zeukfo0">
            <p className="max-w-[560px] text-[17px] leading-relaxed text-chalk/80 lg:text-lg" data-id="element-212" data-mp="2lkilk95g629t">
              We find the actual cause, explain what we found in plain language,
              and give you the information to decide what happens next. That is
              the East End Automotive Way.
            </p>

            <div className="mt-7" data-id="element-213" data-mp="ibgnkzh73tmc">
              <a href={business.phoneHref} className="inline-flex max-w-full items-center justify-center gap-3 rounded-md bg-brand px-6 py-4 font-display text-lg font-bold tracking-tight text-white transition-colors duration-150 ease-out hover:bg-brand-light sm:px-7" data-id="element-214" data-mp="ichy92uaue3j">
                <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-215" data-mp="15zq69sj44199" />
                Call {business.phone}
              </a>
            </div>

            <p className="mt-5 text-sm text-chalk/60" data-id="element-216" data-mp="x02zssbj059c">
              Monday – Friday, 8:00 AM – 5:00 PM · {business.address.street},{' '}
              {business.address.city}, {business.address.state}
            </p>
          </div>
        </div>
      </div>
    </section>;
}